import { Avatar, Tooltip } from "@material-ui/core";
import { Box } from "@mui/material";
import { GridActionsCellItem } from "@mui/x-data-grid-pro";
import jwt_decode from "jwt-decode";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { ReactComponent as FilterIcon } from "../../../src/assets/Customer/FilterIcon.svg";
import { ReactComponent as FilterIconHover } from "../../../src/assets/Customer/FilterIconHover.svg";
import CommonUtil from "../../Util/CommonUtils";
import { REACT_URL_DASHBOARD } from "../../actions/EndPoints";
import DataTableLatest from "../../components/DataTable/DataTableLatest";
import HeaderToolbar from "../../components/HeaderToolbar";
import Toast from "../../components/ToastContainer/CustomToast";
import { exportCustomerBydealerId } from "../../services/Invitations/ExportDealerService";
import { fetchCustomersByDealerId } from "../../slices/Customer/CustomerSlice";
import { postChildSwitchCompany } from "../../slices/DashboardPanel/DashboardPanelSlice";
import SimpleDialogDemo from "../Approvals/ImageDailogBox";
import ExportDialog from "../DailyReports/ExportDialog";
import ImpersonationIcon from "../Dealer/ImpersonationIcon";
import ViewIcon from "../Invitations/ViewIcon";
import CustomerDetailsByDealerIdExports from "./CustomerDetailsByDealerIdExports";
import CustomersReportByDealerIdFilter from "./CustomersReportByDealerIdFilter";

function CustomersReportByDealerId(props) {
  const [clear, setClear] = React.useState(false);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [rows, setRows] = useState([]);
  const [page, setPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [id, setId] = useState(props.location.state?.id);
  const history = useHistory();
  const [openDownload, setOpenDownload] = useState(false);
  const [openFilter, setOpenFilter] = useState(false);
  const [date, setDate] = useState();
  const [loading, setLoading] = useState(true);
  const [paging, setPaging] = useState({
    pageNumber: 1,
    pageSize: 50,
  });
  const [fileFormat, setFileFormat] = useState("1");
  const [noOfRecords, setNoOfRecords] = useState("0");
  const [inputValue, setInputValue] = useState("");
  const [toInputValue, setToInputValue] = useState("");
  const [isLivePhoto, setIsLivePhoto] = useState(false);
  const [isSignature, setIsSignature] = useState(false);
  const [closemodel, setClosemodel] = useState(false);
  const companySettings = JSON.parse(localStorage.getItem("companySettings"));
  const [isHovered, setIsHovered] = useState(false);

  const handleChange = (newPage, size) => {
    setPage(newPage);
    setPaging({
      pageNumber: newPage,
      pageSize: size,
    });
  };

  const [offset, setOffset] = useState("");

  useEffect(() => {
    const getLocalOffset = () => {
      const now = new Date();
      const offsetMinutes = now.getTimezoneOffset();
      const offsetHours = Math.floor(Math.abs(offsetMinutes) / 60);
      const offsetMinutesRemain = Math.abs(offsetMinutes) % 60;
      const sign = offsetMinutes > 0 ? "-" : "+";
      return `${sign}${String(offsetHours).padStart(2, "0")}:${String(
        offsetMinutesRemain
      ).padStart(2, "0")}`;
    };

    setOffset(getLocalOffset());
  }, []);

  const resetFilter = () => {
    setClear(false);
    setPaging({ ...paging, page: 1 });
    setFilter(defaultFilter);
  };

  const [filter, setFilter] = React.useState({
    status: "",
    name: "",
    email: "",
    subscriptionName: "",
  });

  const defaultFilter = {
    status: "",
    name: "",
    email: "",
    subscriptionName: "",
  };

  const applyFilter = (data) => {
    setClear(true);
    setPaging({ ...paging, page: 1 });
    setFilter({
      ...filter,
      status: data.status,
      name: data.name,
      email: data.email,
      subscriptionName: data.subscriptionName,
    });
  };

  const handleFileFormatChange = (event) => {
    setFileFormat(event.target.value);
  };

  const handleDataRecordsChange = (event) => {
    setNoOfRecords(event.target.value);
  };

  const handleCheckBoxLivePhoto = (event) => {
    setIsLivePhoto(event.target.checked);
  };
  const handleCheckBoxSignature = (event) => {
    setIsSignature(event.target.checked);
  };
  const handleInputChange = (event) => {
    const value = event.target.value;
    if (
      /^\d*$/.test(value) &&
      (value === "" ||
        (parseInt(value, 10) > 0 && parseInt(value, 10) <= 10000))
    ) {
      setInputValue(value);
    }
  };

  const handleToInputChange = (event) => {
    const value = event.target.value;
    if (
      /^\d*$/.test(value) &&
      (value === "" ||
        (parseInt(value, 10) > 0 && parseInt(value, 10) <= 10000))
    ) {
      setToInputValue(value);
    }
  };

  const handleExportCustomer = (data) => {
    if (fileFormat == "2") {
      setIsLivePhoto(false);
      setIsSignature(false);
    }
    var searchParam = "";
    if (filter.name !== undefined && !CommonUtil.isEmptyString(filter.name)) {
      searchParam += "&name=" + encodeURIComponent(filter.name);
    }
    if (filter.email !== undefined && !CommonUtil.isEmptyString(filter.email)) {
      searchParam += "&email=" + encodeURIComponent(filter.email);
    }
    if (
      filter.subscriptionName !== undefined &&
      !CommonUtil.isEmptyString(filter.subscriptionName)
    ) {
      searchParam +=
        "&subscriptionName=" + encodeURIComponent(filter.subscriptionName);
    }
    searchParam += "&timeZone=" + encodeURIComponent(offset);
    searchParam +=
      "&datepattern=" + formatDate(companySettings?.adminAndDealerDateFormat);

    const stats = {
      fileType: fileFormat,
      from: inputValue === "" ? "0" : inputValue,
      to: toInputValue === "" ? "0" : toInputValue,
    };

    dispatch(
      exportCustomerBydealerId(onSuccess, onFailure, stats, id, searchParam)
    )
      .unwrap()
      .then((data) => {
        if ((data.code = "CVAI0000" && data.data)) {
          onSuccess();
        } else {
          onFailure();
        }
      })
      .catch((er) => {});
  };

  const onSuccess = () => {
    setClosemodel(true);

    return Toast(t("EXPORTSUCC001"), "success");
  };

  const onFailure = () => {
    Toast(t("COMMON000"), "error");
  };

  useEffect(() => {
    loadData(filter, paging);
  }, [filter, paging]);

  const loadData = (filter, paging) => {
    setLoading(true);
    const payload = {
      pageNumber: paging.pageNumber,
      pageSize: paging.pageSize,
      status: filter.status,
      name: filter.name,
      email: filter.email,
      subscriptionName: filter.subscriptionName,
      dealerId: id,
    };

    dispatch(fetchCustomersByDealerId(payload))
      .unwrap()
      .then((res) => {
        if (res.code === "MSGS4024") {
          setLoading(false);
          setRows(res.data.companies);
          setTotalRecords(res.data.totalCount);
          setPage(res.data.currentPage);
          setTotalPages(res.data.totalPages);
        } else {
          setRows([]);
        }
      });
  };

  const handleTextOverflow = (text) => {
    if (text && text.length > 15) {
      return text.substring(0, 15) + "...";
    } else {
      return text;
    }
  };

  const handleView = (params) => {
    history.push({
      pathname: "/vis/viewCustomerReport",
      state: params,
    });
  };

  const handleFilterIcon = () => {
    setOpenFilter(true);
  };

  const handleImpersonation = (params) => {
    if (params.row.status === "INACTIVE") {
      return Toast(t("IMPERSONATION_ERROR"), "error");
    }
    const payload = {
      companyId: params.row.id,
      impersonatingCompanyName: params.row.name,
      impersonatingCompanyEmail: params.row.email,
      impersonatingadminName: params.row.adminName,
    };
    dispatch(postChildSwitchCompany(payload))
      .unwrap()
      .then((data) => {
        if (data.code === "UASI0011") {
          localStorage.removeItem(process.env.REACT_APP_TEMP_TOKEN);
          localStorage.setItem(
            process.env.REACT_APP_ACCESS_TOKEN,
            "Bearer " + data.data.access_token
          );
          const decoded = jwt_decode(data.data.access_token);
          localStorage.setItem("companyId", decoded.companyId);
          localStorage.setItem("companyName", decoded.companyName);
          localStorage.setItem("companyType", decoded.companyType);
          localStorage.setItem("companyCode", decoded.companyCode);
          if (decoded.companyType === "CUSTOMER") {
            window.location.href = REACT_URL_DASHBOARD;
          }
        } else {
          Toast(data.message, "error");
        }
      });
  };

  const formatDate = (dateFormat) => {
    switch (dateFormat) {
      case "DD-MM-YYYY":
        return "dd-MM-yyyy HH:mm";
      case "MM-DD-YYYY":
        return "MM-dd-yyyy HH:mm";
      case "YYYY-MM-DD":
        return "yyyy-MM-dd HH:mm";
      default:
        return "yyyy-MM-dd HH:mm";
    }
  };

  const renderCellNextPaymentDuedate = (date) => (params) => {
    const subscriptionEndDateValue = params.row.subscriptionEndDate;

    if (!subscriptionEndDateValue) {
      return <span className="table-cell-trucate"></span>;
    }
    const formattedDate = moment(
      CommonUtil.getLocalDateTimeInYearFormat(subscriptionEndDateValue)
    ).format(
      date === "dd-MM-yyyy HH:mm"
        ? "DD-MM-YYYY HH:mm"
        : date === "MM-dd-yyyy HH:mm"
        ? "MM-DD-YYYY HH:mm"
        : "YYYY-MM-DD HH:mm"
    );
    return <span className="table-cell-trucate">{formattedDate}</span>;
  };

  const testBackGroundColors = [
    "#C7D4E7",
    "#F8EACD",
    "#DBE1D7",
    "#EBD3E1",
    "#E2DEED",
    "#EBD3D3",
    "#D7EEE8",
    "#D3F5D5",
    "#E5D9C3",
    "#D2C785",
    "#C6E0E3",
    "#E4D8EB",
    "#D0D1DC",
    "#CCE1D8",
    "#CBDAEC",
    "#F6FCE1",
    "#F6FCE1",
    "#DBD0CE",
    "#C3DFCF",
    "#E6D8E5",
    "#C3EBE1",
    "#C0E5F5",
    "#EBE3B1",
    "#F6CFCF",
    "#ECD4E9",
    "#D5F6CF",
    "#DAD9F5",
    "#F2E1CB",
  ];

  const textColors = [
    "#2D4568",
    "#6C5629",
    "#2F4B1C",
    "#491D37",
    "#20163B",
    "#572626",
    "#214C42",
    "#275E2B",
    "#7D6845",
    "#677820",
    "#29666D",
    "#4E2168",
    "#1E203A",
    "#194130",
    "#143F70",
    "#586E0C",
    "#392871",
    "#543935",
    "#395847",
    "#6D3969",
    "#085341",
    "#1E3C4A",
    "#3E380D",
    "#481515",
    "#381434",
    "#163610",
    "#13123E",
    "#30210E",
  ];

  const getAvatarColor = (name) => {
    const colors = [
      "#C7D4E7",
      "#F8EACD",
      "#DBE1D7",
      "#EBD3E1",
      "#E2DEED",
      "#EBD3D3",
      "#D7EEE8",
      "#D3F5D5",
      "#E5D9C3",
      "#D2C785",
      "#C6E0E3",
      "#E4D8EB",
      "#D0D1DC",
      "#CCE1D8",
      "#CBDAEC",
      "#F6FCE1",
      "#F6FCE1",
      "#DBD0CE",
      "#C3DFCF",
      "#E6D8E5",
      "#C3EBE1",
      "#C0E5F5",
      "#EBE3B1",
      "#F6CFCF",
      "#ECD4E9",
      "#D5F6CF",
      "#DAD9F5",
      "#F2E1CB",
    ];
    const index =
      name.split("").reduce((acc, char) => acc + char.charCodeAt(0), 0) %
      colors.length;
    return colors[index];
  };

  const ZoomHandaler = (params) => {
    const { name, imagePreSignedURL } = params.row;

    const getColorIndex = (name) => {
      const total = name
        .toUpperCase()
        .split("")
        .reduce((sum, char) => sum + char.charCodeAt(0), 0);
      return total % testBackGroundColors.length;
    };

    const initials = `${name?.charAt(0) || ""}`;
    const bgColor = !imagePreSignedURL
      ? getAvatarColor(initials)
      : "transparent";
    const colorIndex = getColorIndex(initials);
    const textColor = imagePreSignedURL ? "inherit" : textColors[colorIndex];

    return (
      <SimpleDialogDemo
        button={
          <Avatar
            style={{
              cursor: "pointer",
              backgroundColor: bgColor,
              color: textColor,
            }}
            alt={name}
            src={imagePreSignedURL || undefined}
          >
            {!imagePreSignedURL && initials.toUpperCase()}
          </Avatar>
        }
        child={
          <Avatar
            style={{
              width: "300px",
              height: "300px",
              border: "1px solid #FFFF",
              fontSize: "100px",
              borderRadius: "50%",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: bgColor,
              color: textColor,
            }}
            alt={name}
            src={imagePreSignedURL || undefined}
          >
            {!imagePreSignedURL && initials.toUpperCase()}
          </Avatar>
        }
      />
    );
  };

  const columns = React.useMemo(
    () => [
      {
        field: "company.profile",
        headerName: "",
        sortable: false,
        width: 5,
        renderCell: (params) => {
          return ZoomHandaler(params);
        },
      },

      {
        field: "companyName",
        headerName: t("CUSTDATABLE01"),
        flex: 1,
        minWidth: 170,
        valueGetter: (params) => params.row.name,
        renderCell: (params) => (
          <Tooltip title={`${params.value}`} placement="bottom-start">
            <span>{handleTextOverflow(params.value)}</span>
          </Tooltip>
        ),
      },

      {
        field: "email",
        headerName: t("CUSTDATABLE02"),
        flex: 1,
        minWidth: 170,
        valueGetter: (params) => params.row.email,
        renderCell: (params) => (
          <Tooltip title={`${params.value}`} placement="bottom-start">
            <span>{handleTextOverflow(params.value)}</span>
          </Tooltip>
        ),
      },

      {
        field: "mobile",
        headerName: t("CUSTDATABLE03"),
        flex: 1,
        minWidth: 190,
        valueGetter: (params) => params.row.phone,
        renderCell: (params) => (
          <Tooltip title={`${params.value}`} placement="bottom-start">
            <span>{handleTextOverflow(params.value)}</span>
          </Tooltip>
        ),
      },

      {
        field: "Subscription",
        headerName: t("CUSTDATABLE05"),
        flex: 1,
        minWidth: 170,
        valueGetter: (params) => params.row.subscriptionName,
        renderCell: (params) => (
          <Tooltip title={`${params.value}`} placement="bottom-start">
            <span>{handleTextOverflow(params.value)}</span>
          </Tooltip>
        ),
      },

      {
        field: "BillingCycle",
        headerName: t("CUSTDATABLE14"),
        flex: 1,
        minWidth: 170,
        valueGetter: (params) => params.row.billingCycle,
        renderCell: (params) => (
          <Tooltip title={`${params.value}`} placement="bottom-start">
            <span>{handleTextOverflow(params.value)}</span>
          </Tooltip>
        ),
      },

      {
        field: "PlanBasePrice",
        headerName: t("CUSTDATABLE20"),
        flex: 1,
        minWidth: 170,
        valueGetter: (params) => params.row.planBasePrice / 100,
        renderCell: (params) => (
          <Tooltip title={`${params.value}`} placement="bottom-start">
            <span>{handleTextOverflow(params.value)}</span>
          </Tooltip>
        ),
      },

      {
        field: "nextPaymentDuedate",
        headerName: t("CUSTDATABLE38"),
        flex: 1,
        minWidth: 190,
        renderCell: renderCellNextPaymentDuedate(
          formatDate(companySettings?.adminAndDealerDateFormat)
        ),
      },

      {
        field: "nextPaymentAmount",
        headerName: t("CUSTDATABLE39"),
        flex: 1,
        minWidth: 190,
        valueGetter: (params) => params.row.planBasePrice / 100,
        renderCell: (params) => (
          <Tooltip title={`${params.value}`} placement="bottom-start">
            <span>{handleTextOverflow(params.value)}</span>
          </Tooltip>
        ),
      },

      {
        field: "DealerName",
        headerName: t("CUSTDATABLE22"),
        flex: 1,
        minWidth: 170,
        valueGetter: (params) => params.row.dealerName,
        renderCell: (params) => (
          <Tooltip title={`${params.value}`} placement="bottom-start">
            <span>{handleTextOverflow(params.value)}</span>
          </Tooltip>
        ),
      },

      {
        field: "Actions",
        headerName: t("ACTION"),
        type: "actions",
        flex: 1,
        minWidth: 165,
        width: 150,
        headerAlign: "center",
        getActions: (params) => [
          <GridActionsCellItem
            icon={<ViewIcon />}
            label={t("VIEW")}
            onClick={() => handleView(params.row)}
          />,
          <GridActionsCellItem
            icon={<ImpersonationIcon />}
            label={t("Impersonation")}
            onClick={() => handleImpersonation(params)}
          />,
        ],
      },
    ],
    [date]
  );

  return (
    <>
      <HeaderToolbar title={t("CUSTDATABLE10")} back_button={true} />
      <Box
        display={"flex"}
        width={"100%"}
        flexDirection={"row"}
        justifyContent={"flex-end"}
        alignItems={"center"}
        gap="5px"
      >
        <Box item>
          <ExportDialog
            rowsPerPage={rowsPerPage}
            applyFilter={(data) => handleExportCustomer(data)}
            totalRecords={totalRecords}
            nameTitle={"Export Customer Details"}
            handleFileFormatChange={handleFileFormatChange}
            handleDataRecordsChange={handleDataRecordsChange}
            handleInputChange={handleInputChange}
            handleToInputChange={handleToInputChange}
            fileFormat={fileFormat}
            noOfRecords={noOfRecords}
            inputValue={inputValue}
            toInputValue={toInputValue}
            setFileFormat={setFileFormat}
            setNoOfRecords={setNoOfRecords}
            setInputValue={setInputValue}
            setToInputValue={setToInputValue}
            setIsLivePhoto={setIsLivePhoto}
            setIsSignature={setIsSignature}
            isLivePhoto={isLivePhoto}
            isSignature={isSignature}
            handleCheckBoxLivePhoto={handleCheckBoxLivePhoto}
            handleCheckBoxSignature={handleCheckBoxSignature}
            dealerPortal={true}
            closemodel={closemodel}
            setClosemodel={setClosemodel}
          />
        </Box>

        <Tooltip title={t("COMMON006")}>
          <Box
            item
            className={"filter"}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            onClick={handleFilterIcon}
          >
            {isHovered ? (
              <FilterIconHover style={{ color: "#474a4e" }} />
            ) : (
              <FilterIcon style={{ color: "#474a4e" }} />
            )}
          </Box>
        </Tooltip>

        <Box item>
          {clear && (
            <Link
              href="#"
              underline="hover"
              className="line"
              style={{
                opacity: "0.8",
                color: "#E3393C",
                fontSize: "14px",
                underline: "hover",
                display: "inline",
              }}
              onClick={resetFilter}
            >
              {t("CLEARFILTER")}
            </Link>
          )}
        </Box>
      </Box>

      <div style={{ height: 300, width: "100%", marginTop: "5px" }}>
        <DataTableLatest
          columns={columns}
          rows={rows}
          page={page}
          count={totalRecords}
          rowId={(row) => row.id}
          pageCount={totalPages}
          pageSize={rowsPerPage}
          handleChange={(newPage, size) => handleChange(newPage, size)}
        />
      </div>

      {openFilter && (
        <CustomersReportByDealerIdFilter
          open={openFilter}
          onClose={() => {
            setOpenFilter(false);
          }}
          rowsPerPage={rowsPerPage}
          applyFilter={applyFilter}
          date={date}
          parentId={id}
        />
      )}

      {openDownload && (
        <CustomerDetailsByDealerIdExports
          open={openDownload}
          handleClose={() => {
            setOpenDownload(false);
          }}
          parentId={id}
          dateFormat={date}
        />
      )}
    </>
  );
}

export default CustomersReportByDealerId;
